/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { SecurityMappingResponse } from '../models/security-mapping-response';
import { MappingFilter } from '../models/mapping-filter';
import { AsReportedSecurity } from '../models/as-reported-security';
import { SecurityToMap } from '../models/security-to-map';
import { Security } from '../models/security';
@Injectable({
  providedIn: 'root',
})
class SecurityMappingService extends __BaseService {
  static readonly getSecurityMappingPath = '/securityMapping';
  static readonly getSecurityMappingDetailsPath = '/securityMapping/details/{securityId}';
  static readonly getSecurityBySecurityTypePath = '/securityMapping/secuirtyType';
  static readonly doMapTheSecurityPath = '/mapSecurity';
  static readonly updateSecurityPath = '/mapSecurity/update';
  static readonly removeSecurityPath = '/mapSecurity/removeSecurity';
  static readonly removeAsReportedSecurityPath = '/mapSecurity/removeAsReportedSecurity';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param mappingFilter undefined
   * @return list of security mappings
   */
  getSecurityMappingResponse(mappingFilter: MappingFilter): __Observable<__StrictHttpResponse<SecurityMappingResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = mappingFilter;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/securityMapping`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SecurityMappingResponse>;
      })
    );
  }
  /**
   * @param mappingFilter undefined
   * @return list of security mappings
   */
  getSecurityMapping(mappingFilter: MappingFilter): __Observable<SecurityMappingResponse> {
    return this.getSecurityMappingResponse(mappingFilter).pipe(
      __map(_r => _r.body as SecurityMappingResponse)
    );
  }

  /**
   * @param securityId undefined
   * @return list of as reported securities attached with security id
   */
  getSecurityMappingDetailsResponse(securityId: number): __Observable<__StrictHttpResponse<Array<AsReportedSecurity>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/securityMapping/details/${encodeURIComponent(String(securityId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<AsReportedSecurity>>;
      })
    );
  }
  /**
   * @param securityId undefined
   * @return list of as reported securities attached with security id
   */
  getSecurityMappingDetails(securityId: number): __Observable<Array<AsReportedSecurity>> {
    return this.getSecurityMappingDetailsResponse(securityId).pipe(
      __map(_r => _r.body as Array<AsReportedSecurity>)
    );
  }

  /**
   * @param securityType undefined
   * @return list of as reported securities similar to security type
   */
  getSecurityBySecurityTypeResponse(securityType: string): __Observable<__StrictHttpResponse<Array<AsReportedSecurity>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (securityType != null) __params = __params.set('securityType', securityType.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/securityMapping/secuirtyType`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<AsReportedSecurity>>;
      })
    );
  }
  /**
   * @param securityType undefined
   * @return list of as reported securities similar to security type
   */
  getSecurityBySecurityType(securityType: string): __Observable<Array<AsReportedSecurity>> {
    return this.getSecurityBySecurityTypeResponse(securityType).pipe(
      __map(_r => _r.body as Array<AsReportedSecurity>)
    );
  }

  /**
   * @param securityToMap undefined
   * @return it will be return boolean that whether issuer was mapped or not.
   */
  doMapTheSecurityResponse(securityToMap: SecurityToMap): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = securityToMap;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/mapSecurity`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param securityToMap undefined
   * @return it will be return boolean that whether issuer was mapped or not.
   */
  doMapTheSecurity(securityToMap: SecurityToMap): __Observable<boolean> {
    return this.doMapTheSecurityResponse(securityToMap).pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * @param securityToUpdate undefined
   * @return it will return a updated security
   */
  updateSecurityResponse(securityToUpdate: Security): __Observable<__StrictHttpResponse<Security>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = securityToUpdate;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/mapSecurity/update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Security>;
      })
    );
  }
  /**
   * @param securityToUpdate undefined
   * @return it will return a updated security
   */
  updateSecurity(securityToUpdate: Security): __Observable<Security> {
    return this.updateSecurityResponse(securityToUpdate).pipe(
      __map(_r => _r.body as Security)
    );
  }

  /**
   * @param params The `SecurityMappingService.RemoveSecurityParams` containing the following parameters:
   *
   * - `securityId`:
   *
   * - `reason`:
   *
   * @return it will return a boolean that whether security was deleted or not.
   */
  removeSecurityResponse(params: SecurityMappingService.RemoveSecurityParams): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.securityId != null) __params = __params.set('securityId', params.securityId.toString());
    if (params.reason != null) __params = __params.set('reason', params.reason.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/mapSecurity/removeSecurity`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param params The `SecurityMappingService.RemoveSecurityParams` containing the following parameters:
   *
   * - `securityId`:
   *
   * - `reason`:
   *
   * @return it will return a boolean that whether security was deleted or not.
   */
  removeSecurity(params: SecurityMappingService.RemoveSecurityParams): __Observable<boolean> {
    return this.removeSecurityResponse(params).pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * @param params The `SecurityMappingService.RemoveAsReportedSecurityParams` containing the following parameters:
   *
   * - `reason`:
   *
   * - `asReportedSecurityId`:
   *
   * @return it will return a boolean that whether as reported security was deleted or not.
   */
  removeAsReportedSecurityResponse(params: SecurityMappingService.RemoveAsReportedSecurityParams): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.reason != null) __params = __params.set('reason', params.reason.toString());
    if (params.asReportedSecurityId != null) __params = __params.set('asReportedSecurityId', params.asReportedSecurityId.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/mapSecurity/removeAsReportedSecurity`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param params The `SecurityMappingService.RemoveAsReportedSecurityParams` containing the following parameters:
   *
   * - `reason`:
   *
   * - `asReportedSecurityId`:
   *
   * @return it will return a boolean that whether as reported security was deleted or not.
   */
  removeAsReportedSecurity(params: SecurityMappingService.RemoveAsReportedSecurityParams): __Observable<boolean> {
    return this.removeAsReportedSecurityResponse(params).pipe(
      __map(_r => _r.body as boolean)
    );
  }
}

module SecurityMappingService {

  /**
   * Parameters for removeSecurity
   */
  export interface RemoveSecurityParams {
    securityId: number;
    reason: string;
  }

  /**
   * Parameters for removeAsReportedSecurity
   */
  export interface RemoveAsReportedSecurityParams {
    reason: string;
    asReportedSecurityId: number;
  }
}

export { SecurityMappingService }
